module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/ja-product3.69ca0eb4.png";